import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";

import { db } from "../../firebase/firebase";
import CategoryServiceCard from "./CategoryServiceCard";

function LoadingCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-5">
      {[0, 1, 2, 3].map((item) => (
        <div
          key={item}
          className={`card-soft overflow-hidden animate-pulse ${
            item === 0 ? "lg:col-span-2" : ""
          }`}
        >
          <div
            className={`bg-[#FFE7D2] ${
              item === 0 ? "aspect-[21/10]" : "aspect-[16/10]"
            }`}
          />

          <div className="p-7">
            <div className="h-8 bg-[#FFE7D2] rounded w-2/3" />
            <div className="h-4 bg-[#FFF0E3] rounded mt-4" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function CategoryServicesGrid({
  categories = [],
  loading,
  error,
  onCategoryClick,
  onSectionClick,
}) {
  const [allSections, setAllSections] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "sections"),
      (snapshot) => {
        const items = snapshot.docs
          .map((document) => ({
            id: document.id,
            ...document.data(),
          }))
          .filter((section) => section.isActive !== false)
          .sort(
            (a, b) =>
              Number(a.displayOrder ?? 0) -
              Number(b.displayOrder ?? 0)
          );

        console.log("Homepage sections:", items);

        setAllSections(items);
      },
      (snapshotError) => {
        console.error("Unable to load homepage sections:", snapshotError);
        setAllSections([]);
      }
    );

    return unsubscribe;
  }, []);

  if (loading) {
    return <LoadingCards />;
  }

  if (error) {
    return (
      <div className="card-soft p-8 text-center">
        <h3 className="font-display text-2xl">
          Categories could not be loaded
        </h3>
        <p className="text-[#5b5a56] mt-2">
          Please refresh the page and try again.
        </p>
      </div>
    );
  }

  if (!categories.length) {
    return (
      <div className="card-soft p-8 text-center">
        <h3 className="font-display text-2xl">
          Categories will be added soon
        </h3>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {categories.map((category, index) => {
        const categorySections = allSections.filter(
          (section) => section.categoryId === category.id
        );

        return (
          <CategoryServiceCard
            key={category.id}
            category={category}
            sections={categorySections}
            index={index}
            onCategoryClick={onCategoryClick}
            onSectionClick={onSectionClick}
          />
        );
      })}
    </div>
  );
}
